import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as platformUtils from 'utils/platform';
import RestHelper from 'utils/RestHelper.js';
import _style from './style.scss';
import { useTranslation, withTranslation } from 'react-i18next';
import {
  Button,
  Col,
  Input,
  Modal,
  Select,
  Space,
  Spin,
  Table,
  DatePicker,
  Row,
  Tooltip,
  TreeSelect,
  message, Popover, Form, Radio, Checkbox, notification
} from 'antd';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import LastReport from 'components/exception/issue/LastReport/LastReport';
import { isNotNullish, isNullish } from 'utils/nullish';
import isString from 'lodash/lang/isString';
import moment from 'moment';
import {
  isAndroid,
  isAndroidOrHarmony,
  isGameConsole,
  isIos,
  isMobile,
  isPc,
  isPcOrLinux,
  isWechatMiniProgram,
  isSwitch,
  isPlaystation,
  PlatformUtil,
} from 'utils/platform';
import { convertIosModelToProductName } from 'utils/model-convert/ios-model-convert';
import { CrashUtil, makeCrashListSearchParamsFromSearchParams } from 'utils/api/crash';
import { fromJS } from 'immutable';
import { formatTime, generateSearch, getIssueDetailUrlPrefix } from 'utils/helper';
import IssueCrashSearchUtil from 'utils/IssueCrashSearchUtil';
import { dataComplianceConfirm } from 'utils/dataComplianceConfirm';
import { isZh, ze } from 'utils/zhEn';
import { connect, useSelector } from 'react-redux';
import { sleep } from 'utils/sleep';
import IssueCrashFilterEx from 'components/commons/IssueCrashFilter/IssueCrashFilterEx';
import {
  FieldName,
  IssueCrashFilterExUtil,
  QueryType
} from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { StackUtil } from 'utils/stack';
import { CrashAttachmentUtil } from 'utils/crash-attachment-util';
import { countryI18n } from 'utils/country';
import DownloadIcon from 'svg/v2/newcs_dashboard_download_icon_normal.svg';
import { CaretDownFilled, CaretUpFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import axios from 'axios';
import uniq from 'lodash/array/uniq';
import { zip, chunk } from 'lodash';
import { ExceptionCategoryUtil } from 'utils/exception-category';
import { getReportCategoryByExceptionTypeInt } from 'utils/constants/exception-type-int';
import { selectCurrentAppIsGameForPeace } from 'utils/selectors/selectors';
import TapdAddCommentModal from './TapdAddCommentModal';
import { UserIdDescriptionConfigUtil } from 'utils/user-id-description-config-util';
import { CS_STYLES } from 'utils/constants/style-constants';
import StackAi from 'svg/v2/newcs_aiassistant_aianalysis.svg';
import { ServerAppSettings } from 'utils/server-app-settings';
import { EnvUtil } from 'utils/env-util';
import useZuStore from 'store/zustand/zustand-store';
import ReportTableConfigModal from '../ReportTableConfigModal/ReportTableConfigModal';
import QueryInaccurateReason from 'utils/constants/query-inaccurate-reason';
import { orange } from '@ant-design/colors';
import { ReportDetailUtil } from '../ReportDetail/ReportDetail';

function createExcel(data,title){
  const { utils } = XLSX;
  var ws_name = "sheet1";
  const wb= utils.book_new();
  /* make worksheet */
  var ws = utils.aoa_to_sheet(data);

  /* Add the worksheet to the workbook */
  XLSX.utils.book_append_sheet(wb, ws, ws_name);
  XLSX.writeFile(wb, title);
}

function tryDecodeUriComponent(s) {
  try {
    return decodeURIComponent(s);
  } catch (e) {
    return s;
  }
}

const TableColumnUserIdRenderer = ({
  text,
}) => {
  const userIdDescriptionInfo = UserIdDescriptionConfigUtil.useCurrentAppParseCsvContentResult();
  const {
    userIdToDescKeyValueList,
  } = userIdDescriptionInfo;
  const descKeyValueList =userIdToDescKeyValueList[text] || [];

  return <div>
    <div
      style={{maxWidth:'300px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}
    >{text}</div>
    { descKeyValueList.map(({ key, value }, i) => {
      return <div
        key={i}
        style={{ fontSize: '12px', color: CS_STYLES.getPrimaryColor(), maxWidth:'300px', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}
      >{ key }: { value }</div>;
    }) }
  </div>;
};

const IssueAiAnalysisButton = ({
  issueId,
  searchConditionGroup,
}) => {
  const { t } = useTranslation();
  const aiDrawerSlice = useZuStore(state => state.aiDrawer);

  function onClickStartAnalysis() {
    // 场景4：按搜索条件分析，每次都使用新的 trigger（因为条件可能不同）
    aiDrawerSlice.startIssueAnalysis(issueId, {
      trigger: `${issueId}-filtered-${Date.now()}`,
      searchConditionGroup,
      forceNewConversation: true,
    });
  }

  return <Tooltip title={ze('对满足搜索条件的上报执行AI分析', 'AI Analyze Reports Matching Filters')}>
    <Button
      style={{
        width:'32px',
        height:'32px',
        paddingTop:'6px',
      }}
      onClick={() => onClickStartAnalysis()}
      icon={<StackAi />}
    >
    </Button>
  </Tooltip>;
};

function tableColumnUserIdOnCell() {
  return {
    style: {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
  };
}

// “重还原上报的堆栈”弹窗中还原范围的枚举
const BatchRetraceScope = {
  PAGE: 'PAGE', // 仅还原当前表格页的上报
  ALL: 'ALL', // 还原全部上报（最多10000条）
};

@connect((state) => {
  return {
    reduxState: state,
  };
}, (dispatch) => ({ dispatch }))
@withTranslation()
export default class ReportRecord extends Component {
  static propTypes = {
    /**
     * 本组件会在两个地方用到，原来是上报列表下面，现在高级搜索展示不聚合上报也用了这个组件
     * true: 表示是高级搜索页面  false: 表示是上报列表页面
     * */
    isFromAdvancedSearch: PropTypes.bool,
    /** 和平定制需求，高级搜索根据输入的tapd单生成搜索条件，然后支持多选上报之后追加tapd评论 */
    tapdUrlForFetchFilterConditions: PropTypes.string,
    isFromFeaturePreview: PropTypes.bool,
    isArchiveCrashList: PropTypes.bool,
    /** 归档 tab：表头排序写 archiveSortField，不写热列表 sortField */
    onSortChange: PropTypes.func,
    sortField: PropTypes.string,
    sortOrder: PropTypes.string,
    user: PropTypes.object,
    appId: PropTypes.string,
    issueId: PropTypes.string,
    issue: PropTypes.object,
    crashResp: PropTypes.object,
    dispatch: PropTypes.func,
    handleSearch: PropTypes.func,
    exceptionType: PropTypes.string,
    isDemoApp: PropTypes.bool,
    changeLog: PropTypes.func,
    changeLevel: PropTypes.func,
    changeLogKey: PropTypes.func,
    getCrashAttachment: PropTypes.func,
    getCrashDoc: PropTypes.func,
    pid: PropTypes.number,
    actions: PropTypes.object,
    selectOptions: PropTypes.object,
    path: PropTypes.string,
    rows: PropTypes.number,
    start: PropTypes.number,
    location: PropTypes.object,
    reduxState: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      isInitDone: false,

      searchConditionGroup: {},

      moreOption: false,
      isDownloading: false,
      downloadingTipText: undefined,
      downloadExceptionRows: 100,
      downloadExceptionWithCustomKv: false,

      searchAfterComponentDidUpdate: false,

      downloadReportsModalVisible: false,
      downloadAttachmentModalVisible: false,
      downloadAttachmentFilename: '',
      downloadAttachmentRows: null,
      allowLargeNumberDownloadRows: false,

      batchRetraceButtonVisible: false,
      batchRetraceModalVisible: false,
      batchRetraceScope: BatchRetraceScope.PAGE,

      selectedRowKeys: [],

      tapdAddCommentModalVisible: false,
      selectReportListKey: []
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    // 默认先关闭
    dispatch({
      type: 'IS_SHOW_CRASHITEM',
      value: '-1',
    });
  }

  componentDidMount() {
    const { appId, pid } = this.props;
    if (appId && pid) {
      this.initRoutine();
    }
  }

  getServerAppSettings() {
    const { appId, reduxState } = this.props;
    return reduxState.app.get('appIdToServerAppSettings')[appId] || {};
  }

  getIsEnableDecryptSdkLog() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.enableDecryptSdkLog];
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { appId, pid } = this.props;
    if (appId && pid && (prevProps.appId !== appId || prevProps.pid !== pid)) {
      this.initRoutine();
    }
    if (!prevState.searchAfterComponentDidUpdate && this.state.searchAfterComponentDidUpdate) {
      this.setState({ searchAfterComponentDidUpdate: false });
      const { handleSearch, issueId, actions } = this.props;
      actions.showLoading();
      handleSearch(issueId).then(actions.hideLoading);
    }
  }

  initRoutine() {
    if (this.state.isInitDone) {
      return;
    }
    this.setState({ isInitDone: true });
    const searchConditionGroup = this.makeSearchConditionGroupFromQuery();
    this.setState({
      searchConditionGroup,
    });
  }

  /**
   * 触发设置search params。旧的条件被全部丢弃。
   * @param {{name: string, value: string}[]} nameValueList
   */
  async setMultipleSearchParams(nameValueList) {
    await this.setOrUpdateMultipleSearchParams(nameValueList, false);
  }

  /**
   * 触发更新search params。 旧的条件保留。
   * @param {{name: string, value: string}[]} nameValueList
   */
  async handleChangeMultiple(nameValueList) {
    await this.setOrUpdateMultipleSearchParams(nameValueList, true);
  }

  /**
   * @param {{name: string, value: string}[]} nameValueList
   * @param {Boolean} isUpdate
   */
  async setOrUpdateMultipleSearchParams(nameValueList, isUpdate) {
    const {
      actions, location, crashResp, pid,
    } = this.props;
    const { searchParams: searchParamsObj } = crashResp;

    let query = { pid };

    nameValueList.filter(x => x && x.name).forEach(({ name, value }) => {
      if (name === 'start' && value === searchParamsObj.start) {
        return false;
      }

      if (typeof name === 'object') {
        query = Object.assign({}, query, name);
      } else {
        query = Object.assign({}, query, {
          [name]: value,
        });
      }
    });
    query = Object.assign(query, { start: query.start || 0 });
    query = IssueCrashSearchUtil.searchParamsObjToUrlQueryObj(query);
    if(this.getPageSize() !== query.rows){
      query.start = 0;
    }
    const oldSearch = isUpdate ? location.search : '';
    await actions.pushState({
      pathname: location.pathname,
      search: generateSearch(oldSearch, query, true),
    });
  }

  async onClickSearchButton(searchConditionGroup) {
    await this.changeQueryFromSearchConditionGroup(searchConditionGroup);
    this.setState({ searchAfterComponentDidUpdate: true });
  }

  isEmpty(value) {
    return (Array.isArray(value) && value.length === 0)
      || (Object.prototype.isPrototypeOf.call({}, value) && Object.keys(value).length === 0);
  }

  // 获取“全部上报（最多10000条）”场景下需要重还原的 crashId 列表，
  // 逻辑与 downloadException 中拉取全量上报的方式一致，但只需要 crashIdList，
  // 因此把 needEsMapList/needRetracedStack/needQueryCustomKv 都关掉，减少接口开销。
  async fetchAllCrashHashListForRetrace() {
    const { appId, pid: platformId, issueId } = this.props;
    const lastSearchUsedSearchParams = this.getNullableLastSearchUsedSearchParams();
    if (!lastSearchUsedSearchParams) {
      message.error('You must searched before retrace.');
      return null;
    }

    const params = makeCrashListSearchParamsFromSearchParams(lastSearchUsedSearchParams);
    const query = params.merge({
      appId,
      platformId,
      issueId,
      start: 0,
      rows: 10000,
      needEsMapList: false,
      needRetracedStack: false,
      needQueryCustomKv: false,
    }).toJS();

    const hideLoading = message.loading(ze('正在获取全部上报列表...', 'Fetching all reports...'), 0);
    try {
      const rsp = await RestHelper.post('/api/crash/queryCrashList', query);
      return rsp.json.ret.crashIdList || [];
    } finally {
      hideLoading();
    }
  }

  async onRetraceConfirm(isRetraceMinidump) {
    const { appId, pid: platformId, issueId, user, exceptionType } = this.props;
    let retraceType = undefined;
    if (isRetraceMinidump) {
      retraceType = ExceptionCategoryUtil.isCrash(exceptionType)
        ? 'MINIDUMP_CRASH'
        : 'MINIDUMP_ERROR';
    }

    const isAllScope = this.state.batchRetraceScope === BatchRetraceScope.ALL;
    const crashHashList = isAllScope
      ? await this.fetchAllCrashHashListForRetrace()
      : this.getTableData().map(record => record.crashId);
    if (!crashHashList) {
      // fetchAllCrashHashListForRetrace 内部已经提示过错误原因
      return;
    }
    if (crashHashList.length === 0) {
      message.warning(ze('没有需要还原的上报', 'No reports to re-symbolicate'));
      return;
    }

    // 开始正式还原前二次确认，避免超管误触导致大批量还原
    const confirmed = await new Promise((resolve) => {
      Modal.confirm({
        title: ze('确认重还原', 'Confirm Re-Symbolicate'),
        content: ze(
          `共 ${crashHashList.length} 条上报，确认开始重还原吗？`,
          `${crashHashList.length} report(s) in total, confirm to start re-symbolicate?`,
        ),
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
    if (!confirmed) {
      return;
    }
    this.setState({ batchRetraceModalVisible: false });

    const instance = Modal.success({
      title: isAllScope
        ? ze('全部上报重试还原堆栈', 'Re-Symbolicate all reports')
        : ze('本页内容重试还原堆栈', 'Re-Symbolicate reports on this page'),
      content: '',
      okButtonProps: { style: { display: 'none' } },
    });
    // 单条请求失败不应中断整体流程，这里统计成功/失败数量，全部处理完后再统一提示
    let successCount = 0;
    let failCount = 0;
    for (const i in crashHashList) {
      const crashHash = crashHashList[i];
      try {
        await RestHelper.mustPost('/api/issue/reRetraceCrash',
          {
            appId,
            platformId,
            issueId,
            crashDataType: 'ReloadCrash',
            crashHash,
            requestLocalUserId: user.get('newUserId'), // 用于帮助定位重还原问题，增加重还原的请求人
            requestUserName: user.get('nickname'),
            retraceType,
          },
        );
        successCount++;
      } catch (e) {
        failCount++;
        console.error('reRetraceCrash failed', crashHash, e);
      }
      instance.update({
        content: `已处理${Number(i) + 1}条,共需处理${crashHashList.length}条（成功${successCount}，失败${failCount}）`
      })
      // 这里是超管内部使用的功能，对时延不敏感，缩短间隔以支撑上万条的还原场景
      await sleep(100);
    }
    instance.destroy();

    // 用需要手动点击确认的 Modal 展示最终结果，避免 message 提示一闪而过导致用户没注意到
    Modal[failCount > 0 ? 'warning' : 'success']({
      title: ze('重还原结果', 'Re-Symbolicate Result'),
      content: ze(
        `共${crashHashList.length}条，成功${successCount}条，失败${failCount}条`,
        `Total ${crashHashList.length}, succeeded ${successCount}, failed ${failCount}`,
      ),
    });
  }

  getNullableLastSearchUsedSearchParams() {
    const { isFromAdvancedSearch, crashResp, reduxState } = this.props;
    if (isFromAdvancedSearch) {
      return reduxState.seniorSearch.get('lastSearchParams');
    } else {
      const { searchParams } = crashResp;
      return fromJS(searchParams);
    }
  }

  async downloadException() {
    await dataComplianceConfirm();
    this.setState({ isDownloading: true });
    const { appId, pid, issue, exceptionType, t, isFromAdvancedSearch } = this.props;
    const issueId = isFromAdvancedSearch
      ? undefined
      : issue.toJS().issueHash.replace(/:/g, '');
    const lastSearchUsedSearchParams = this.getNullableLastSearchUsedSearchParams();
    if (!lastSearchUsedSearchParams) {
      message.error('You must searched before download.');
      return;
    }

    const params = makeCrashListSearchParamsFromSearchParams(lastSearchUsedSearchParams);
    const query = params.merge({
      appId,
      platformId: pid,
      issueId,
      start: 0,
      rows: this.state.downloadExceptionRows,
      needEsMapList: true,
      needRetracedStack: true,
      needQueryCustomKv: this.state.downloadExceptionWithCustomKv,
    }).toJS();
    const rsp = await RestHelper.post('/api/crash/queryCrashList', query);
    const {
      crashDatas,
      crashIdList,
      crashIdToCustomKvMap: nullableCrashIdToCustomKvMap,
      esMapList,
    } = rsp.json.ret;
    const crashIdToCustomKvMap = nullableCrashIdToCustomKvMap || {};

    let allCustomKeyList = [];
    if (nullableCrashIdToCustomKvMap) {
      const allDupKeys = Object.values(crashIdToCustomKvMap).map(x => Object.keys(x)).flat();
      allCustomKeyList = uniq(allDupKeys);
    }
    const crashIdToEsMap = Object.fromEntries((esMapList || []).map(x => [x.crashId, x]));

    const refinedCrashDatas = Object.fromEntries(Object.entries(crashDatas).map(([k, v]) => {
      v = v || {};
      const appInBackString = String(v.appInBack);
      let feStatusText = t("REPORTDETAIL.unknown");
      if (appInBackString === 'false') {
        feStatusText = t("REPORTDETAIL.foreground");
      } else if (appInBackString === 'true') {
        feStatusText = t("REPORTDETAIL.background");
      }
      const exceptionCategory = ExceptionCategoryUtil.fromExceptionTypeInt(v.crashExceptionType);
      const issueDetailUrlPrefix = getIssueDetailUrlPrefix(exceptionCategory);
      const newV = {
        ...v,
        feStatusText,
        countryText: countryI18n(v.country || v.srcCountry) || '-',
        crashReportUrlText: `${window.location.origin}/${issueDetailUrlPrefix}/${appId}/${v.issueId}/report-id/${v.crashId}?pid=${pid}`,
        isVmText: String(v.isVirtualMachine > 0),
        elapsedTimeText: isNotNullish(v.elapsedTime) ? formatTime(v.elapsedTime) : '-',
        retraceCrashDetailLineCount: StackUtil.splitStackIntoLines(v.retraceCrashDetail, pid).filter(x => x.trim()).length,
        customKvMap: crashIdToCustomKvMap[k] || {},
        gpu: crashIdToEsMap[k]?.gpu || '',
        gpuDriverVersion: crashIdToEsMap[k]?.displayVersion || '',
        cpuText: ReportDetailUtil.renderCpuText(v, pid),
        socText: ReportDetailUtil.renderSocText(v),
      };
      return [k, newV];
    }));

    const fileTitle = isFromAdvancedSearch
      ? ze('高级搜索上报列表.xlsx', 'AdvancedSearchReportList.xlsx')
      : `${issueId}.xlsx`;
    const columnKeyInfos = [
      { label: t('issueCrashFilterKey.issueId'), dataIndex: 'issueId', available: isFromAdvancedSearch },
      { label: t('issueCrashFilterKey.expUid'), dataIndex: 'expUid' },
      { label: t('issueCrashFilterKey.crashId'), dataIndex: 'crashId' },
      { label: 'URL', dataIndex: 'crashReportUrlText' },
      { label: t('issueCrashFilterKey.crashTime'), dataIndex: 'crashTime' },
      { label: t('issueCrashFilterKey.userId'), dataIndex: 'userId' },
      { label: t('issueCrashFilterKey.deviceId'), dataIndex: 'deviceId' },
      { label: t('issueCrashFilterKey.uploadTime'), dataIndex: 'uploadTime' },
      { label: t('issueCrashFilterKey.version'), dataIndex: 'productVersion' },
      { label: t('REPORTDETAIL.feStatus'), dataIndex: 'feStatusText' },
      ...(isPcOrLinux(pid) ? [] : [
        { label: t('REPORTDETAIL.设备商品名'), dataIndex: 'model' },
        { label: ze('设备原始Model','Original Device Model'), dataIndex: 'modelOriginalName' },
      ]),
      { label: t("REPORTDETAIL.cpu"), dataIndex: 'cpuText' },
      { label: t('issueCrashFilterKey.soc'), dataIndex: 'socText', available: isAndroid(pid) },
      { label: t("issueCrashFilterKey.osVersion"), dataIndex: 'osVer' },
      { label: t('issueCrashFilterKey.rom'), dataIndex: 'rom', available: isAndroidOrHarmony(pid) },
      { label: t('issueCrashFilterKey.vmStatus'), dataIndex: 'isVmText', available: isAndroidOrHarmony(pid) },
      { label: t('issueCrashFilterKey.elapsedTime'), dataIndex: 'elapsedTimeText' },
      { label: t('issueCrashFilterKey.country'), dataIndex: 'countryText' },
      { label: t('issueCrashFilterKey.gpu'), dataIndex: 'gpu', available: isPc(pid, appId) },
      { label: t('issueCrashFilterKey.gpuDriverVersion'), dataIndex: 'gpuDriverVersion', available: isPc(pid, appId) },
      { label: t('issueCrashFilterKey.crashDetail'), dataIndex: 'retraceCrashDetail' },
      { label: ze('出错堆栈行数', 'Lines of Error Stack'), dataIndex: 'retraceCrashDetailLineCount' },
      { label: t('issueCrashFilterKey.crashExpName'), dataIndex: 'expName' },
      { label: t('issueCrashFilterKey.crashExpMessage'), dataIndex: 'expMessage' },
      ...allCustomKeyList.map(x => ({ label: x, dataIndex: x, isCustomKv: true }))
    ].filter(x => isNullish(x.available) || x.available);
    const columnTitles = columnKeyInfos.map(x => isString(x) ? x : x.label);
    const columnDatas = crashIdList.map(id => columnKeyInfos.map(column => {
      const dataIndex = isString(column) ? column : column.dataIndex;
      const isCustomKv = !!column.isCustomKv;
      return isCustomKv
        ? refinedCrashDatas[id]?.customKvMap?.[dataIndex] || ''
        : refinedCrashDatas[id][dataIndex] || '';
    }));
    this.setState({ isDownloading: false });
    createExcel([columnTitles, ...columnDatas], fileTitle);
  }

  async batchDownloadAttachments() {
    const {
      appId, pid, issue, isFromAdvancedSearch,
    } = this.props;

    const downloadAttachmentFilename = this.state.downloadAttachmentFilename;
    const rows = this.state.downloadAttachmentRows;
    const isDownloadPcMinidump = downloadAttachmentFilename === 'Minidump.dmp.gz';

    const isDownloadPcSdkLog = downloadAttachmentFilename === 'logFile.log';
    const isDownloadMobileSdkLog = PlatformUtil.isMobileOrMobileLike(pid)
      && downloadAttachmentFilename === CrashAttachmentUtil.getSdkLogFilename(pid);
    const isDownloadSdkLog = isDownloadPcSdkLog || isDownloadMobileSdkLog;
    const isDownloadSdkAttach = downloadAttachmentFilename === CrashAttachmentUtil.getSdkAttachFilename(pid);

    const isDownloadPcOtherThreads = isPcOrLinux(pid) && downloadAttachmentFilename === 'OtherThreads.txt';
    const fileInfo = CrashAttachmentUtil.getInfoByFilename(downloadAttachmentFilename);
    const { isBase64Encoded } = (fileInfo || {});
    const alias = fileInfo?.downloadFilename || fileInfo?.alias || downloadAttachmentFilename;

    const needRetraceOtherThreads = downloadAttachmentFilename === 'trace.zip'
      || downloadAttachmentFilename === 'OtherThreads.txt'
      || downloadAttachmentFilename === 'NativeOtherThreads.txt';

    if (!downloadAttachmentFilename) {
      message.error(ze('附件名不能为空', 'Attachment not selected.'));
      return;
    }
    if (!rows) {
      message.error(ze('条数不能为空', 'Rows not selected.'));
      return;
    }

    await dataComplianceConfirm();
    this.setState({ isDownloading: true, downloadingTipText: ze('下载中，请稍候', 'Downloading.') });

    const lastSearchUsedSearchParams = this.getNullableLastSearchUsedSearchParams();
    if (!lastSearchUsedSearchParams) {
      message.error('You must searched before download.');
      return;
    }

    const issueId = isFromAdvancedSearch
      ? undefined
      : issue.toJS().issueHash.replace(/:/g, '');
    const params = makeCrashListSearchParamsFromSearchParams(lastSearchUsedSearchParams);
    const query = params.merge({
      appId,
      platformId: pid,
      issueId,
      start: 0,
      rows,
    }).toJS();

    let zipFile = new JSZip();

    // PC minidump: attachment（已适配fetchMultipleCrashAttachments）。
    // 移动SDK log: cos直下。
    // PC log：cos直下 + attachment（为了兼容新旧SDK） 。
    // 其他附件：attachment
    if (!isDownloadPcOtherThreads && !isDownloadMobileSdkLog && !isDownloadSdkAttach) {
      // 先调用 queryCrashList 获取所有要下载的 crashIdList
      const crashListRsp = await RestHelper.post('/api/crash/queryCrashList', query);
      const { crashIdList } = crashListRsp.json.ret;
      const totalCount = crashIdList.length;

      // 每100条分为一组进行下载
      let completeCount = 0;
      const chunkSize = 100;
      const crashIdChunks = chunk(crashIdList, chunkSize);

      for (let i = 0; i < crashIdChunks.length; i++) {
        const crashIdChunk = crashIdChunks[i];
        let retryCount = 0;
        const maxRetries = 3;
        let success = false;

        while (retryCount < maxRetries && !success) {
          try {
            const rsp = await RestHelper.post('/redir/api/data/fetchMultipleCrashAttachments', {
              appId,
              crashIdList: crashIdChunk,
              attachmentFilenameList: [downloadAttachmentFilename],
              needRetraceOtherThreads,
            });
            const {crashIdAndAttachmentsList} = rsp.json.data;
            crashIdAndAttachmentsList.forEach(({crashId, expUid, attachments}) => {
              const attach = attachments[0];
              if (isNullish(attach)) {
                return;
              }
              const {content} = attach;
              let downloadContent = isBase64Encoded
                ? Uint8Array.from(window.atob(content), c => c.charCodeAt(0))
                : content;
              const refinedContent = CrashAttachmentUtil.refineFileContent(pid, downloadAttachmentFilename, downloadContent);
              if (isNotNullish(attach)) {
                zipFile.file(`${expUid || crashId}_${alias}`, refinedContent);
              }
            });
            success = true;
          } catch (e) {
            retryCount++;
            console.error(`Error fetching crash attachments (attempt ${retryCount}/${maxRetries}):`, e);

            if (retryCount >= maxRetries) {
              notification.error({
                message: ze('附件下载失败', 'Attachment Download Failed'),
                description: ze(
                  `第 ${i + 1} 批次下载失败，已重试 ${maxRetries} 次。请稍后重试或减少下载条数。`,
                  `Batch ${i + 1} failed after ${maxRetries} attempts. Please try again later or reduce the number of items.`
                ),
                duration: 0,
              });
              this.setState({ isDownloading: false, downloadingTipText: undefined });
              return;
            }
          }
        }

        completeCount += crashIdChunk.length;
        this.setState({ downloadingTipText: `${completeCount} / ${totalCount}` });
      }
    }
    if (isDownloadSdkLog || isDownloadSdkAttach) {
      const rsp = await RestHelper.post('/api/crash/queryCrashList', query);
      const { crashDatas } = rsp.json.ret;
      const crashMapList = Object.values(crashDatas);
      const totalCount = crashMapList.length;
      const attachmentFilenameList = isDownloadSdkLog ? ['SDK_LOG'] : ['SDK_ATTACH'];

      // 判断是否是加密SDK log（注意SDK attach不需要走解密逻辑）
      const isEncryptedSdkLog = isDownloadSdkLog && this.getIsEnableDecryptSdkLog();
      const fetchEndpoint = isEncryptedSdkLog
        ? '/redir/api/data/fetchNGRDecodedAttachments'
        : '/redir/api/data/fetchSdkUploadedAttachments';

      // Create a map for quick lookup
      const crashIdToCrashMap = {};
      crashMapList.forEach(crashMap => {
        crashIdToCrashMap[crashMap.crashId] = crashMap;
      });

      let completeCount = 0;
      // 加密SDK log的接口只支持一次下载一个，所以chunkSize必须是1
      const chunkSize = isEncryptedSdkLog ? 1 : 100;
      const crashMapChunks = chunk(crashMapList, chunkSize);

      for (const crashMapChunk of crashMapChunks) {
        try {
          const fetchRsp = await RestHelper.mustPost(fetchEndpoint, {
            appId,
            partialCrashMapList: crashMapChunk.map(x => CrashAttachmentUtil.makePartialCrashMapForSdkUploadedFile(x)),
            attachmentFilenameList,
          });
          const { crashIdAndAttachmentsList } = fetchRsp.json.data;

          for (const item of (crashIdAndAttachmentsList || [])) {
            const { crashId, attachments } = item;
            const crashMap = crashIdToCrashMap[crashId];
            const { expUid, sdkVersion } = crashMap || {};
            const attachment = attachments?.[0];

            if (attachment) {
              const { content: contentBase64 } = attachment;
              const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
              const filename = isDownloadSdkLog
                ? CrashAttachmentUtil.getSdkLogFilename(pid, sdkVersion)
                : CrashAttachmentUtil.getSdkAttachFilename(pid, sdkVersion);
              zipFile.file(`${expUid || crashId}_${filename}`, uint8Array);
            }
          }
        } catch (e) {
          console.error('Error fetching SDK attachments:', e);
        }

        completeCount += crashMapChunk.length;
        this.setState({ downloadingTipText: `${completeCount} / ${totalCount}` });
      }
    }
    if (isDownloadPcOtherThreads) {
      const crashListRsp = await RestHelper.post('/api/crash/queryCrashList', query);
      const { crashDatas } = crashListRsp.json.ret;
      const crashMapList = Object.values(crashDatas);
      const totalCount = crashMapList.length;
      const reqFileList = crashMapList
        .map(x => {
          let { otherBreakpadCosKey, expUid } = x;
          if (!otherBreakpadCosKey) {
            return null;
          } else {
            if (isPcOrLinux(pid) && !otherBreakpadCosKey?.endsWith('.dmp.gz')) {
              otherBreakpadCosKey = otherBreakpadCosKey + '.dmp.gz';
            }
            return {
              expUid,
              cosKey: otherBreakpadCosKey,
              compressFormat: 'GZIP',
            };
          }
        })
        .filter(x => x);
      let completeCount = totalCount - reqFileList.length;
      const chunkSize = 100;
      const reqChunks = chunk(reqFileList, chunkSize);
      let cosKeyToFileContent = {};
      for (const fileListChunk of reqChunks) {
        const rsp = await RestHelper.post('/redir/api/file/batchDecompressInflateFiles', {
          appId,
          fileList: fileListChunk,
        });
        const { fileList: rspFileList } = rsp.json.data;
        for (const [reqFile, rspFile] of zip(fileListChunk, rspFileList)) {
          const { cosKey } = reqFile;
          const { hasFile, contentBase64 } = rspFile;
          if (hasFile) {
            const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
            const text = new TextDecoder().decode(uint8Array);
            cosKeyToFileContent[cosKey] = text;
          }
        }
        completeCount += fileListChunk.length;
        this.setState({ downloadingTipText: `${completeCount} / ${totalCount}` });
      }

      reqFileList.forEach(x => {
        const { expUid, cosKey } = x;
        const content = cosKeyToFileContent[cosKey] || '';
        zipFile.file(`expUid_${expUid}_other_threads.txt`, content);
      });
    }

    const blob = await zipFile.generateAsync({type: 'blob'});
    saveAs(blob, `${alias}.zip`);
    message.success(ze('附件已成功下载', 'Attachments downloaded successfully.'));
    this.setState({ isDownloading: false, downloadingTipText: undefined, downloadAttachmentModalVisible: false });
  }

  getPageSize() {
    const { rows } = this.props;
    return rows;
  }

  getPageNumber() {
    const { start } = this.props;
    return Math.floor(start / this.getPageSize()) + 1;
  }

  getIsClientSidePagination() {
    const { isFromFeaturePreview } = this.props;
    return !!isFromFeaturePreview;
  }

  getHideInnerPagination() {
    return !!this.props.isArchiveCrashList;
  }

  // 控制显示和显示顺序
  handleControlColumns = (value) => {
    this.setState({ selectReportListKey: value });
  }

  getTableColumns() {
    const { appId, pid, t, exceptionType } = this.props;
    const isClientSidePagination = this.getIsClientSidePagination();
    const isJankCategory = ExceptionCategoryUtil.isJank(exceptionType);
    const { selectReportListKey } = this.state;

    const isMobilePlatform = isMobile(pid);
    const isMobileOrMobileLike = PlatformUtil.isMobileOrMobileLike(pid);
    const isAndroidPlatform = isAndroid(pid);
    const isPcPlatform = isPc(pid, appId);
    const isWechatMiniProgramPlatform = isWechatMiniProgram(pid);
    const isSwitchPlatform = isSwitch(pid);
    const isPlaystationPlatform = isPlaystation(pid);

    const initColumns = [{
      dataIndex: 'crashId',
      title: t('REPORTRECORD.postId'),
      relatedFieldName: FieldName.crashId,
    }, {
      dataIndex: 'userId',
      title: t('REPORTDETAIL.userId'),
      width: '300px',
      render: (text) => <TableColumnUserIdRenderer text={text}/>,
      onCell: tableColumnUserIdOnCell,
      relatedFieldName: FieldName.userId,
    }, {
      dataIndex: 'deviceId',
      title: t('issueCrashFilterKey.deviceId'),
      width: '200px',
      render: (text) => text || '-',
      relatedFieldName: FieldName.deviceId,
    }, {
      dataIndex: 'productVersion',
      title: t('REPORTRECORD.version'),
      width: '200px',
      relatedFieldName: FieldName.version,
    }, {
      dataIndex: 'crashTime', // 因为要排序，必须指定原始字段
      title: t('REPORTRECORD.发生时间'),
      sorter: isClientSidePagination ? undefined : true,
      render: (text, record) => record.crashTimeFormatted,
      width: '250px',
      relatedFieldName: FieldName.crashTime,
    }, {
      dataIndex: 'uploadTime', // 因为要排序，必须指定原始字段
      title: t('REPORTRECORD.postTime'),
      sorter: isClientSidePagination ? undefined : true,
      render: (text, record) => record.uploadTimeFormatted,
      width: '250px',
      relatedFieldName: FieldName.issueUploadTime,
    }, {
      dataIndex: 'model',
      disabled: !isMobilePlatform,
      title: t('REPORTRECORD.hardware'),
      onCell() {
        return {
          style: {
            paddingTop: '2px',
            paddingBottom: '2px',
          }
        };
      },
      render: (text, record) => {
        let { model, modelOriginalName } = record || {};
        return CrashUtil.formatDeviceName(modelOriginalName, model);
      },
      width: '350px',
      relatedFieldName: FieldName.model,
    }, {
      dataIndex: 'osVer',
      title: t('REPORTRECORD.osVersion'),
      render: (text) => {
        if (!isIos(pid)) {
          return text;
        }
        return tryDecodeUriComponent(text);
      },
      width: '250px',
      relatedFieldName: FieldName.osVersion,
    }, {
      dataIndex: 'processName',
      title: t('issueCrashFilterKey.processName'),
      render: (text) => text || '-',
      width: '200px',
      relatedFieldName: FieldName.processName,
      disabled: !isMobileOrMobileLike,
    }, {
      dataIndex: 'threadName',
      title: t('issueCrashFilterKey.threadName'),
      render: (text) => text || '-',
      width: '200px',
      relatedFieldName: FieldName.threadName,
      disabled: isWechatMiniProgramPlatform || isPlaystationPlatform,
    }, {
      dataIndex: 'bundleId',
      title: t('issueCrashFilterKey.bundleId'),
      render: (text) => text || '-',
      width: '200px',
      relatedFieldName: FieldName.bundleId,
      disabled: !isMobilePlatform,
    }, {
      dataIndex: 'elapsedTime',
      title: t('issueCrashFilterKey.elapsedTime'),
      render: (text) => ReportDetailUtil.renderElapsedTimeForTable(text),
      width: '150px',
      relatedFieldName: FieldName.elapsedTime,
      disabled: isWechatMiniProgramPlatform || isSwitchPlatform,
    }, {
      dataIndex: 'appInBack',
      title: t('issueCrashFilterKey.appInBack'),
      render: (text) => ReportDetailUtil.renderAppInBackForTable(text, t),
      width: '120px',
      relatedFieldName: FieldName.appInBack,
      disabled: !isMobileOrMobileLike,
    }, {
      dataIndex: 'rom',
      title: t('issueCrashFilterKey.rom'),
      render: (text) => ReportDetailUtil.renderRomForTable(text),
      width: '200px',
      relatedFieldName: FieldName.rom,
      disabled: !isAndroidPlatform,
    }, {
      dataIndex: 'appBit',
      title: t('issueCrashFilterKey.appBit'),
      render: (text) => ReportDetailUtil.renderAppBitForTable(text),
      width: '100px',
      relatedFieldName: FieldName.appBit,
      disabled: !isAndroidPlatform,
    },     {
      dataIndex: 'cpu',
      title: t('issueCrashFilterKey.cpu'),
      render: (text, record) => ReportDetailUtil.renderCpuText(record, pid),
      width: '200px',
      relatedFieldName: FieldName.cpu,
    }, {
      dataIndex: 'soc',
      title: t('issueCrashFilterKey.soc'),
      render: (text, record) => ReportDetailUtil.renderSocText(record),
      width: '200px',
      relatedFieldName: FieldName.soc,
      disabled: !isAndroidPlatform,
    }, {
      dataIndex: 'brand', // PC端GPU存在crashMap.brand字段
      title: t('issueCrashFilterKey.gpu'),
      render: (text) => ReportDetailUtil.renderGpuForTable(text),
      width: '200px',
      relatedFieldName: FieldName.gpu,
      disabled: !isPcPlatform,
    }, {
      dataIndex: 'gpuDriverVersion',
      title: t('issueCrashFilterKey.gpuDriverVersion'),
      render: (text) => text || '-',
      width: '150px',
      relatedFieldName: FieldName.gpuDriverVersion,
      disabled: !isPcPlatform,
    }, {
      dataIndex: 'expUid',
      title: t('issueCrashFilterKey.expUid'),
      render: (text) => text || '-',
      width: '200px',
      relatedFieldName: FieldName.expUid,
    }, {
      dataIndex: 'countryOrRegion',
      title: t('issueCrashFilterKey.countryOrRegion'),
      render: (text) => ReportDetailUtil.renderCountryOrRegionForTable(text),
      width: '180px',
      relatedFieldName: FieldName.countryOrRegion,
      disabled: EnvUtil.isChinaEnv(),
    }, {
      dataIndex: 'vmType',
      title: t('issueCrashFilterKey.vmType'),
      render: (text) => ReportDetailUtil.renderVmTypeForTable(text),
      width: '120px',
      relatedFieldName: FieldName.vmType,
      disabled: !isAndroidPlatform,
    }, {
      dataIndex: 'jankAvgTime',
      relatedFieldName: FieldName.jankAvgTime,
      title: ze('卡顿Root时长(ms)', 'Jank Time (ms)'),
      width: '120px',
      align: 'right',
      render: (text, record) => {
        const { expMessage } = record;
        // expMessage的格式是Jank=123.45ms，用正则把后面的123.45ms这部分取出来
        const jankAvgTime = (expMessage || '').match(/=(\d*\.?\d*)ms/);
        return jankAvgTime ? jankAvgTime[1] : '-';
      },
      disabled: !isJankCategory
    }];

    // 控制columns的显示顺序
    let columns;
    if (selectReportListKey && selectReportListKey.length > 0) {
      // 创建一个映射，方便快速查找列配置
      const columnMap = initColumns.filter(x => !x.disabled).reduce((map, column) => {
        map[column.relatedFieldName] = column;
        return map;
      }, {});

      // 根据selectReportListKey的顺序重新排列列
      const orderedColumns = [];
      selectReportListKey.forEach(relatedFieldName => {
        if (columnMap[relatedFieldName]) {
          orderedColumns.push(columnMap[relatedFieldName]);
        }
      });

      columns = orderedColumns;
    } else {
      columns = initColumns.filter(x => !x.disabled);
    }

    if (!this.props.isArchiveCrashList) {
      return columns;
    }
    const resolvedSortField = this.props.sortField || 'uploadTime';
    const resolvedSortOrder = this.props.sortOrder || 'descend';
    return columns.map(col => ({
      ...col,
      sortOrder: col.sorter && col.dataIndex === resolvedSortField ? resolvedSortOrder : null,
    }));
  }

  getTableData() {
    const { crashResp } = this.props;
    const { crashIdList, crashDatas } = crashResp;
    return (crashIdList || []).map((x) => {
      const v = CrashUtil.makeRefinedCrashMap(crashDatas[x] || {});
      return {
        ...v,
        key: v.crashId,
      };
    });
  }

  async onTableChange(pagination, filters, sorter, { action }) {
    if (this.props.isArchiveCrashList) {
      if (action === 'sort' && this.props.onSortChange) {
        const { field, order } = sorter;
        this.props.onSortChange({ sortField: field, sortOrder: order });
      }
      return;
    }
    if (action === 'paginate') {
      const { current, pageSize } = pagination;
      if (this.getPageSize() !== pageSize || this.getPageNumber() !== current) {
        const rows = pageSize;
        const start = (current - 1) * pageSize;
        await this.handleChangeMultiple([
          { name: 'rows', value: rows },
          { name: 'start', value: start },
        ]);
        this.setState({ searchAfterComponentDidUpdate: true });
      }
    } else if (action === 'sort') {
      const { field, order } = sorter;
      const desc = order === 'descend';
      await this.handleChangeMultiple([
        { name: 'sortField', value: isNotNullish(order) ? field : null },
        { name: 'desc', value: desc },
      ]);
      this.setState({ searchAfterComponentDidUpdate: true });
    }
  }

  async onTableExpandedRowsChange(expandedRows) {
    const {
      isFromAdvancedSearch,
      isFromFeaturePreview,
    } = this.props;

    const oldExpandedKey = this.props.reduxState.issue.get('expandedCrashListTableRowKey');
    const newExpandedKey = expandedRows.find(x => x !== oldExpandedKey) || null;

    const { actions } = this.props;
    if (isFromAdvancedSearch || isFromFeaturePreview) {
      actions.resetAllDataInCurrentIssue(); // 高级搜索、特征分析预览列表，清空全部current issue+crash信息
    } else {
      actions.resetCrashRelatedInfoInCurrentIssue();  // 清空旧的上报相关信息
    }
    actions.updateReduxIssueState({ expandedCrashListTableRowKey: newExpandedKey });

    const { crashId, issueId } = this.getTableData().find(x => x.key === newExpandedKey) || {};
    if (!crashId) {
      return;
    }
    if (this.props.isArchiveCrashList) {
      this.fetchCrashDetailByCrashId(crashId);
      return;
    }
    if (!issueId) {
      return;
    }
    if (isFromAdvancedSearch || isFromFeaturePreview) {
      actions.showLoading();
      await actions.getIssueInfo(issueId);
    }
    this.fetchCrashDetailByCrashId(crashId);
  }

  closeTableExpandedRows() {
    const { actions } = this.props;
    actions.resetCrashRelatedInfoInCurrentIssue();  // 清空旧的上报相关信息
    actions.updateReduxIssueState({ expandedCrashListTableRowKey: null });
  }

  fetchCrashDetailByCrashId(crashId) {
    const { getCrashDoc, getCrashAttachment, actions, issueId, pid, exceptionType, issue } = this.props;
    let id = crashId;
    if (platformUtils.isPcOrLinux(crashId)) {
      id = crashId.toLowerCase();
    }

    /* LastReport里面已经有拉取附件逻辑，不需要在这里再拉取附件
    const tasks = !PlatformUtil.hasCrashAttachment(pid, exceptionType)
      ? [getCrashDoc(issueId, id)]
      : [getCrashDoc(issueId, id), getCrashAttachment(issueId, id)];
     */
    const tasks =  [getCrashDoc(issueId, id)];

    actions.showLoading();
    Promise.all(tasks).then(() => {
      actions.hideLoading();
    });
  }

  getCrashTimeRange() {
    const { crashResp } = this.props;
    const { searchParams } = crashResp;
    const { crashTimeBeginMillis, crashTimeEndMillis } = searchParams;
    return [crashTimeBeginMillis, crashTimeEndMillis].map(x => x && moment(Number(x)));
  }

  renderTag(userTag, serverTag) {
    if (`${userTag}` !== '0' && `${serverTag}` !== '0') {
      return userTag + serverTag;
    } else {
      return '-';
    }
  }

  getSelectedVersions() {
    const { crashResp } = this.props;
    const { searchParams } = crashResp;
    const { version } = searchParams;
    return (version && version !== 'all') ? version.split(';') : [];
  }

  makeSearchConditionGroupFromQuery() {
    // const { searchParams } = this.props;
    const urlQueryObj = Object.fromEntries(new URLSearchParams(window.location.search));
    const searchParamsDict = IssueCrashSearchUtil.urlQueryObjToSearchParamsObj(urlQueryObj);
    const searchConditionGroup = IssueCrashFilterExUtil.makeSearchConditionGroupFromSearchParamsDict(searchParamsDict);
    if (searchConditionGroup && (searchConditionGroup.conditions || []).length > 0) {
      return searchConditionGroup;
    }
    // default conditions
    return {
      conditions: [
        { field: FieldName.version },
        { field: FieldName.crashUploadTime, queryType: QueryType.RANGE_RELATIVE_DATETIME, gte: 7 * 86400 * 1000 },
        { field: FieldName.crashDetail },
      ],
    }
  }

  async changeQueryFromSearchConditionGroup(searchConditionGroup) {
    const searchParamsDict = IssueCrashFilterExUtil.makeSearchParamsDictFromSearchConditionGroup(searchConditionGroup);
    const queryNameValueList = Object.entries(searchParamsDict).map(x => ({ name: x[0], value: x[1] }));
    await this.setMultipleSearchParams(queryNameValueList);
  }

  makeFilterOptions() {
    const {
      selectOptions,
    } = this.props;
    const {
      version,
      bundleIdList,
      channelList,
    } = selectOptions.size ? selectOptions.toJS() : {};

    return {
      version: (version.options || []).filter(x => x.value && x.value !== 'all'),
      bundleId: ((bundleIdList || {}).options || []).filter(x => x.value && x.value !== 'all'),
      channelId: ((channelList || {}).options || []).filter(x => x.value && x.value !== 'all'),
      exceptionTypeList: [],
      tagList: [],
      status: [],
      processor: [],
    }
  }

  renderFilter() {
    const { pid } = this.props;
    return <IssueCrashFilterEx
      platformId={pid}
      hideIssueFields
      enableCrashExtraFields={true}
      hiddenFieldList={[FieldName.issueId]}
      searchConditionGroup={this.state.searchConditionGroup}
      filterOptions={this.makeFilterOptions()}
      onChange={({ searchConditionGroup }) => {
        this.setState({
          searchConditionGroup,
        });
        this.changeQueryFromSearchConditionGroup(searchConditionGroup)
      }}
      onSubmit={({ searchConditionGroup }) => {
        this.setState({
          searchConditionGroup,
        });
        this.onClickSearchButton(searchConditionGroup);
      }}
    />;

  }

  renderDownloadReportsModal() {
    const { t, appId, pid, issue } = this.props;
    const rowOptions = [100, 500, 1000, 5000, 10000].map(x => ({ label: x, value: x }));

    const supportDownloadWithCustomKv = !isGameConsole(pid);

    const modalContent = <div>
      <Row align='middle' gutter='10'>
        <Col flex='none'>{ ze('要导出的最近上报条数：','Recent records to export:') }</Col>
        <Col flex='none'><Select
          style={{ width: '100px' }}
          options={rowOptions}
          value={this.state.downloadExceptionRows}
          onChange={(v) => this.setState({ downloadExceptionRows: v })}
        /></Col>
      </Row>
      { supportDownloadWithCustomKv && <div style={{ marginTop: '12px' }}>
        <Checkbox
          value={this.state.downloadExceptionWithCustomKv}
          onChange={e => this.setState({ downloadExceptionWithCustomKv: e.target.checked })}
        >{ ze('包含自定义字段', 'Include Custom Key-Values') }</Checkbox>
      </div> }
    </div>;

    return <Modal
      visible={this.state.downloadReportsModalVisible}
      title={t("REPORTRECORD.导出异常")}
      width='480px'
      onOk={() => {
        this.downloadException();
      }}
      onCancel={() => { this.setState({ downloadReportsModalVisible: false }) }}
      okButtonProps={{ disabled: this.state.isDownloading }}
    >{ modalContent }</Modal>;
  }

  getDownloadAttachmentRowOptionValues(filename) {
    const { pid } = this.props;
    let res = this.state.allowLargeNumberDownloadRows
      ? [10, 100, 200, 500, 1000, 10000]
      : [100, 200, 500, 1000];
    
    // PC minidump附件下载方式不同，而且偏大，所以限制只能少下一些
    if (filename === 'Minidump.dmp.gz') {
      return res.map(x => x / 10);
    }
    
    // 加密SDK log的接口一次只能下载一个，所以需要限制下载条数
    const isDownloadSdkLog = filename === CrashAttachmentUtil.getSdkLogFilename(pid);
    if (isDownloadSdkLog && this.getIsEnableDecryptSdkLog()) {
      return res.map(x => x / 10);
    }
    
    return res;
  }

  renderDownloadAttachmentModal() {
    const { t, appId, pid, issue } = this.props;
    const attachmentFilenameOptions = [
      'valueMapOthers.txt',
      ...((isAndroidOrHarmony(pid) || isPcOrLinux(pid)) ? ['extraMessage.txt'] : []),
      ...(isIos(pid) ? ['crash_attach.log'] :[]),
      ...(isPcOrLinux(pid) ? ['crashSightLog.log'] :[]),
      ...(isAndroidOrHarmony(pid) ? ['crashsightlog.zip'] :[]),
      ...(isIos(pid) ? ['crashsightlog.txt'] :[]),
      ...(isPcOrLinux(pid) ? ['logFile.log'] :[]),
      ...(isPcOrLinux(pid) ? [CrashAttachmentUtil.getSdkAttachFilename()]: []),
      ...(isPcOrLinux(pid) ? ['Minidump.dmp.gz'] :[]),
      ...((isIos(pid) || isPcOrLinux(pid)) ? ['OtherThreads.txt'] :[]),
      ...(PlatformUtil.isMobileOrMobileLike(pid) ? [CrashAttachmentUtil.getSdkLogFilename(pid)] : []),
      ...(isAndroidOrHarmony(pid) ? ['trace.zip'] : []),
      isAndroid(pid) && { value: 'log.txt', label: ze('系统日志', 'System Log') },
      isAndroid(pid) && { value: 'NativeOtherThreads.txt', label: ze('Native全线程堆栈', 'Native Other Threads') },
    ]
    .filter(x => x)
    .map(x => {
      if (typeof x === 'object') {
        return x;
      } else {
        const fileInfo = CrashAttachmentUtil.getInfoByFilename(x);
        const label = (fileInfo || {}).alias || x;
        return { label, value: x };
      }
    });
    const rowOptions = this.getDownloadAttachmentRowOptionValues(this.state.downloadAttachmentFilename).map(x => ({ label: x, value: x }));

    const modalContent = <Spin
      spinning={this.state.isDownloading}
      tip={this.state.downloadingTipText}
    ><div>
      <Form style={{ width: '100%' }} labelCol={{ style: { width: isZh() ? '150px' : '200px' } }}>
        <Form.Item label={ze('要导出的附件', 'Attachment File')}>
          <Select
            options={attachmentFilenameOptions}
            value={this.state.downloadAttachmentFilename}
            onChange={(v) => this.setState({
              downloadAttachmentFilename: v,
              downloadAttachmentRows: this.getDownloadAttachmentRowOptionValues(v)[0],
            })}
          />
        </Form.Item>
        <Form.Item label={ze('要导出的上报条数','Recent records to download')}>
          <div
            onContextMenu={(e) => {
              e.preventDefault();
              this.setState({ allowLargeNumberDownloadRows: true });
            }}
          ><Select
            options={rowOptions}
            value={this.state.downloadAttachmentRows}
            onChange={(v) => this.setState({ downloadAttachmentRows: v })}
          /></div>
        </Form.Item>
      </Form>
    </div></Spin>;

    return <Modal
      visible={this.state.downloadAttachmentModalVisible}
      maskClosable={false}
      title={t("REPORTRECORD.导出附件")}
      width='480px'
      onOk={() => {
        this.batchDownloadAttachments();
      }}
      onCancel={() => { this.setState({ downloadAttachmentModalVisible: false }) }}
      okButtonProps={{ disabled: this.state.isDownloading }}
    >{ modalContent }</Modal>;
  }

  renderBatchRetraceModal() {
    const { t } = this.props;
    const isSuperAdmin = !!this.props.reduxState.user.get('current').get('isSuper');

    const modalContent = <div>
      { isSuperAdmin && <div style={{ marginBottom: '8px', fontSize: '12px' }}>（超管提示）非超管用户可以右键点击“导出附件”激活批量重还原功能。</div>}
      <Radio.Group
        style={{ marginBottom: '16px' }}
        value={this.state.batchRetraceScope}
        onChange={(e) => this.setState({ batchRetraceScope: e.target.value })}
      >
        <Radio value={BatchRetraceScope.PAGE}>{ ze('本页上报', 'Reports in this page') }</Radio>
        <Radio value={BatchRetraceScope.ALL}>{ ze('全部上报（最多10000条）', 'All reports (up to 10000)') }</Radio>
      </Radio.Group>
      <div>
        <Button
          onClick={() => this.onRetraceConfirm(false)}
        >{ t("LASTREPORT.客户端回溯堆栈") }</Button>
        <Button
          style={{ marginLeft: '24px' }}
          onClick={() => this.onRetraceConfirm(true)}
        >{ t("LASTREPORT.服务器回溯堆栈") }</Button>
      </div>
    </div>;

    return <Modal
      visible={this.state.batchRetraceModalVisible}
      maskClosable={false}
      title={ze('重还原上报的堆栈','Resymbolicate Reports')}
      width='480px'
      footer={null}
      onCancel={() => this.setState({ batchRetraceModalVisible: false })}
    >{ modalContent }</Modal>
  }

  onRowSelectionChange(selectedRowKeys, selectedRows) {
    this.setState({ selectedRowKeys });
  }

  handleTapdAddCommentModalOk = (tapdUrl) => {
    // 关闭modal
    this.setState({
      tapdAddCommentModalVisible: false,
      selectedRowKeys: [],
    });
  }

  handleTapdAddCommentModalCancel = () => {
    // 关闭modal
    this.setState({
      tapdAddCommentModalVisible: false,
    });
  }

  render() {
    const {
      issue, crashResp, appId, pid, issueId, dispatch, path, t, user,
      changeLog, changeLevel, changeLogKey, isDemoApp, actions,
      isFromAdvancedSearch,
      tapdUrlForFetchFilterConditions,
      isFromFeaturePreview,
      reduxState,
    } = this.props;

    const currentAppFromJs = reduxState.app.get('current');
    const demoApp = currentAppFromJs.get('demoApp');
    const serverAppSettings = reduxState.app.get('appIdToServerAppSettings')[appId] || {};
    const enableAiAnalyse = serverAppSettings[ServerAppSettings.keys.enableAiAnalyse];
    const enableIssueAiAnalysis = !isFromAdvancedSearch && issueId && !demoApp && (EnvUtil.isChinaEnv() || enableAiAnalyse);

    // 和平定制化需求，通过tapd单正文中按照模板配置的内容，自动填充搜索条件
    const isGameForPeace = selectCurrentAppIsGameForPeace(reduxState);
    const enableFetchFilterConditionsFromTapd = isFromAdvancedSearch && isGameForPeace;

    const isClientSidePagination = this.getIsClientSidePagination();
    const hideInnerPagination = this.getHideInnerPagination();

    const expandedCrashListTableRowKey = this.props.reduxState.issue.get('expandedCrashListTableRowKey');
    const { crashId: crashHash } = this.getTableData().find(x => x.key === expandedCrashListTableRowKey) || {};

    const maxListedCrashCount = 1000;
    const queryInaccurateReason = crashResp.queryInaccurateReason;
    const paginationTotal = Math.min(crashResp.numFound, maxListedCrashCount); // 限制深度分页，只能通过分页器查询前1000条
    const isSuperAdmin = !!this.props.reduxState.user.get('current').get('isSuper');
    const hasCrashRows = Array.isArray(crashResp.crashIdList) && crashResp.crashIdList.length > 0;

    return (
      <div className={isFromAdvancedSearch ? undefined : classnames(_style.issue_container, _style.reportDetailContainer)}>
        { !isFromAdvancedSearch && <div>
          { this.renderFilter() }
        </div> }
        { queryInaccurateReason === QueryInaccurateReason.CRASH_LIST_QUERY_CRASH_EXTRA_LIST_OVERFLOW && <div>
          <div style={{ margin: '0', width: '100%', color: orange.primary, fontSize: '12px' }}>
            <Space>
              <ExclamationCircleOutlined/>
              <div>{ ze(`搜索条件范围过大，搜索结果可能存在遗漏。请尝试缩小搜索条件范围（例如上报时间）。`, `Search conditions are too broad, search results may be missing. Please try narrowing the search scope (e.g. report time).`) }</div>
            </Space>
          </div>
        </div> }
        { !isFromFeaturePreview && <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '12px 0 12px 0' }}><Space>
            { hasCrashRows && !this.props.isArchiveCrashList && this.state.selectedRowKeys.length > 0 && <Button
              onClick={() => this.setState({ tapdAddCommentModalVisible: true })}
            >将选中上报追加到TAPD单评论区</Button> }
            { hasCrashRows && !this.props.isArchiveCrashList && enableIssueAiAnalysis && <IssueAiAnalysisButton
              issueId={issueId}
              searchConditionGroup={this.state.searchConditionGroup}
            /> }
            { hasCrashRows && !this.props.isArchiveCrashList && <Button
              disabled={this.state.isDownloading}
              onClick={() => this.setState({ downloadReportsModalVisible: true })}
            ><div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <DownloadIcon />
              <div>{ t('REPORTRECORD.导出异常') }</div>
            </div></Button> }
            { hasCrashRows && !this.props.isArchiveCrashList && (isPcOrLinux(pid) || !isGameConsole(pid)) && <Button
              disabled={this.state.isDownloading}
              onClick={() => this.setState({ downloadAttachmentModalVisible: true })}
              onContextMenu={() => this.setState({ batchRetraceButtonVisible: true })}
            ><div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <DownloadIcon />
              <div>{ t('REPORTRECORD.导出附件') }</div>
            </div></Button>}
            { hasCrashRows && !this.props.isArchiveCrashList && !isFromAdvancedSearch && (isSuperAdmin || this.state.batchRetraceButtonVisible) && <Button
              onClick={() => this.setState({ batchRetraceModalVisible: true, batchRetraceScope: BatchRetraceScope.PAGE })}
            >{isSuperAdmin && '（超管）'}{ze('重还原上报的堆栈','Re-Symbolicate Reports')}</Button>}
            <ReportTableConfigModal appId={this.props.appId} pid={pid} t={this.props.t} handleControlColumns={this.handleControlColumns} exceptionType={this.props.exceptionType} />
          </Space></div>
        }
        <Table
          columns={this.getTableColumns()}
          sortDirections={['descend', 'ascend', 'descend']}
          dataSource={this.getTableData()}
          scroll={{ x: 'max-content'}}
          rowSelection={ enableFetchFilterConditionsFromTapd ? {
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: this.onRowSelectionChange.bind(this),
          } : undefined}
          pagination={hideInnerPagination ? false : isClientSidePagination ? { showTotal: (total) => t('common.共n条', { count: total }) } : {
            defaultPageSize: this.getPageSize(),
            pageSize: this.getPageSize(),
            defaultCurrent: this.getPageNumber(),
            current: this.getPageNumber(),
            total: paginationTotal,
            showTotal: () => t('common.共n条', { count: crashResp.numFound }),
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 50, 100],
          }}
          expandable={{
            expandRowByClick: true,
            expandedRowKeys: expandedCrashListTableRowKey ? [expandedCrashListTableRowKey] : [],
            expandedRowRender: (record) => {
              if (record.key !== expandedCrashListTableRowKey) {
                return null;
              }
              const { crashExceptionType } = record;
              const exceptionType = getReportCategoryByExceptionTypeInt(crashExceptionType);

              return <div>
              <LastReport
                {...{
                  appId,
                  pid,
                  issueId: record.issueId,
                  issue,
                  dispatch,
                  exceptionType,
                  changeLog,
                  changeLevel,
                  changeLogKey,
                  isReport: true,
                  style: _style,
                  isDemoApp,
                  crashHash,
                  path,
                  user,
                  closeCrashItem: this.closeTableExpandedRows.bind(this),
                }}
              />
            </div>},
            onExpandedRowsChange: this.onTableExpandedRowsChange.bind(this),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <Button size='small' style={{ width: 16, height: 16, borderRadius: 4 }} icon={<CaretUpFilled style={{ fontSize: 12 }} />} onClick={e => onExpand(record, e)}></Button>
              ) : (
                <Button size='small' style={{ width: 16, height: 16, borderRadius: 4 }} icon={<CaretDownFilled style={{ fontSize: 12 }} />} onClick={e => onExpand(record, e)}></Button>
              )
          }}
          onChange={isClientSidePagination ? undefined : this.onTableChange.bind(this)}
        />
        { this.renderDownloadReportsModal() }
        { this.renderDownloadAttachmentModal() }
        { this.renderBatchRetraceModal() }
        <TapdAddCommentModal
          visible={this.state.tapdAddCommentModalVisible}
          initTapdUrl={tapdUrlForFetchFilterConditions}
          onOk={this.handleTapdAddCommentModalOk}
          onCancel={this.handleTapdAddCommentModalCancel}
          selectedReports={this.getTableData().filter(report => this.state.selectedRowKeys.includes(report.key))}
        />
      </div>
    );
  }
}
